module.exports = __webpack_public_path__ + "img/manual1.9a332176.png";